<template>
  <div>
    <span v-if="hasHelpdeskTickets && helpdeskTickets.length <= 2">
      {{ inlineDisplay }}
    </span>
    <div v-else-if="hasHelpdeskTickets">
      <div
        v-for="ticket in helpdeskTickets"
        :key="ticket.id || ticket.helpdeskTicketId">
        {{ ticket.helpdeskTicketId }}
      </div>
    </div>
    <span v-else>
      {{ fallbackDisplay }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'HelpdeskTicketsCell',

  props: {
    helpdeskTickets: {
      type: Array,
      default: () => [],
    },
    helpdeskId: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    hasHelpdeskTickets() {
      return Array.isArray(this.helpdeskTickets) && this.helpdeskTickets.length > 0;
    },
    inlineDisplay() {
      return this.helpdeskTickets
        .map((ticket) => ticket.helpdeskTicketId)
        .join(' / ');
    },
    fallbackDisplay() {
      return this.helpdeskId ? this.helpdeskId : '-';
    },
  },
};
</script>
